<template>
  <div>
    <lab-header ref="lab_header" page-name="Publications"></lab-header>
    <cramb-header page-name="Publications" :path="path"></cramb-header>
    <div class="global">
      <div class="pdfContainer">
        <div style="padding: 20px">
          <el-button type="primary" size="mini" @click="scaleD()"><i class="el-icon-zoom-in"></i></el-button>
          <el-button type="primary" size="mini" @click="scaleX()"><i class="el-icon-zoom-out"></i></el-button>
          <el-button type="success" size="mini" @click="prev()">上一页</el-button>
          <el-button type="success" size="mini" @click="next()">下一页</el-button>
          <el-button type="primary" size="mini" @click="clockwise()"><i class="el-icon-refresh-right"></i></el-button>
          <el-button type="primary" size="mini" @click="antiClockwise()"><i class="el-icon-refresh-left"></i></el-button>
        </div>
        <div style="align-items: center;width: 100%;justify-content: center; ">
          <div class="pdf">
          <pdf
            ref="pdf"
            :page="currentPage"
            :rotate="pageRotate"
            :src="src"
            @loaded="loadPdfHandler"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event"
          ></pdf>
        </div>
        </div>
        <div class="page">
          <span class="pageNum">{{ currentPage }}</span>
          <span class="pageNum">/</span>
          <span class="pageNum">{{ pageCount }}</span>
        </div>
        <div style="padding: 20px;">
          <el-button type="primary" size="mini" @click="scaleD()"><i class="el-icon-zoom-in"></i></el-button>
          <el-button type="primary" size="mini" @click="scaleX()"><i class="el-icon-zoom-out"></i></el-button>
          <el-button type="success" size="mini" @click="prev()">上一页</el-button>
          <el-button type="success" size="mini" @click="next()">下一页</el-button>
          <el-button type="primary" size="mini" @click="clockwise()"><i class="el-icon-refresh-right"></i></el-button>
          <el-button type="primary" size="mini" @click="antiClockwise()"><i class="el-icon-refresh-left"></i></el-button>
        </div>
      </div>
    </div>
    <lab-footer></lab-footer>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import LabHeader from '../components/public/LabHeader'
import LabFooter from '../components/public/LabFooter'
import CrambHeader from '../components/public/CrambHeader'
export default {
  name: 'PDFShow',
  components: { CrambHeader, pdf, LabFooter, LabHeader },
  data () {
    return {
      path: [
        {
          name: 'Home',
          url: '/'
        },
        {
          name: 'Publications',
          url: '/publications'
        },
        {
          name: '文档预览',
          url: '/pdf'
        }
      ],
      src: '',
      currentPage: 0,
      pageCount: 0,
      scale: 100,
      pageRotate: 0,
      isShow: false,
      showUrl: '',
      showUrlMap: {
        '1': '../../static/pdf/2016_ACS_Sustainable_Chemistry_Engineering.pdf',
        '2': '../../static/pdf/2018_Industrial_Crops_&_Products.pdf',
        '3': '../../static/pdf/2018_Molecules.pdf',
        '4': '../../static/pdf/2019_ACS_omega.pdf',
        '5': '../../static/pdf/2019_Industrial_Crops_&_Products.pdf',
        '6': '../../static/pdf/2020_Journal_of_Agricultural_and_Food_Chemistry.pdf',
        '7': '../../static/pdf/2021_Journal_of_Agricultural_and_Food_Chemistry.pdf',
        '8': '../../static/pdf/2022_Journal_of_Agricultural_and_Food_Chemistry.pdf',
        '9': '../../static/pdf/2022_Pest_management_Science.pdf',
        '10': '../../static/pdf/2021mao.pdf',
        '11': '../../static/pdf/2020tao.pdf',
        '12': '../../static/pdf/2020wu.pdf',
        '13': '../../static/pdf/2019gao.pdf',
        '14': '../../static/pdf/2018gao.pdf',
        '15': '../../static/pdf/2018gao_2.pdf',
        '16': '../../static/pdf/2016li.pdf'
      }
    }
  },
  methods: {
    // pdf加载时
    loadPdfHandler (e) {
      this.currentPage = 1 // 加载的时候先加载第一页
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + '%'
      this.$refs.pdf.$el.style.height = parseInt(this.scale) + '%'
    },
    //  上一页
    prev () {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    // 下一页
    next () {
      if (this.currentPage < this.pageCount) {
        this.currentPage++
      }
    },
    // 放大
    scaleD () {
      if (this.scale === 100) return this.$message.warning('已经是最大喽~~')
      this.scale += 10
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + '%'
      this.$refs.pdf.$el.style.height = parseInt(this.scale) + '%'
    },
    // 缩小
    scaleX () {
      if (this.scale === 40) return this.$message.warning('已经是最小喽~~')
      this.scale += -10
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + '%'
      this.$refs.pdf.$el.style.height = parseInt(this.scale) + '%'
    },
    // 顺时针
    clockwise () {
      this.pageRotate += 90
    },
    // 逆时针
    antiClockwise () {
      this.pageRotate -= 90
    }
  },
  mounted () {
    this.src = this._.get(this.showUrlMap, this.$route.params.id, this.showUrlMap['1'])
    this.path[2].name = '文档预览'
    this.path[2].url = this.src
    console.log(this.src)
  }
}
</script>

<style scoped>
/*.global {*/
/*  width: 100%;*/
/*  align-items: center;*/
/*}*/

.pdfContainer {
  width: 100%;
  /*height: calc(100% - 50px);*/
}
.pdfContainer .button {
  width: 100%;
  height: 50px;
  /*display: flex;*/
  align-items: center;
}
.pdfContainer .pdf {
  width: 100%;
  align-items: center;
  /*height: calc(100% - 500px);*/
  /*max-height: 800px;*/
  /*overflow-y: auto;*/
}
.pdfContainer .page {
  width: 100%;
  height: 50px;
}

.pageNum {
  font-size: 18px;
}
.el-button--mini, .el-button--mini.is-round {
    padding: 6px 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/PDFShow.vue